import React, { useState, useEffect } from 'react'
import { DivTag } from '../../Components/Tags/Tags'
import Seo from '../../Components/SeoComponent/Seo'
import { HeadTag } from '../../Components/Tags/Tags'
import { showSuccessToast, showErrorToast } from '../../utils/toastUtils'
import Loader from '../../Loader'
import { useSearchParams } from 'react-router-dom'

// Import service and modal components
import { downloadCreditReport } from "../../Services/CreditReport/reportService";
import TransUnionReportModal from "../EquifaxMenu/TransUnionScore/TransUnionReport";
import TransUnionReportModal2 from "../EquifaxMenu/TransUnionScore2/TransUnionReport";
import EquifaxScoreReportModal from "../EquifaxMenu/EquifaxCrScorev2/Equifaxscorev2Report";
import ExperianScoreReportModal from "../EquifaxMenu/Experian2/ExperianScoreReport";
import ExperianScoreReportModals from "../EquifaxMenu/Experian/ExperianScoreReport";
import CrifScoreReportModal from "../EquifaxMenu/CrifCreditScore/CrifScoreReport";
import { MobileDataModal } from "../CreditReport/MobileDataModal";
import ExperianScoreReportModal3 from '../EquifaxMenu/Experian3/ExperianScoreReport3';
import CrifScoreReportModal2 from '../EquifaxMenu/CrifCreditScore2/CrifCreditScore2';

const CreditScorePDF = () => {
  const [showLoader, setShowLoader] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [reportError, setReportError] = useState(null);
  const [currentServiceCode, setCurrentServiceCode] = useState('');
  const [reportMessage, setReportMessage] = useState('');
  const [currentReference, setCurrentReference] = useState('');

  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Extract reference and type from URL query params
    const reference = searchParams.get('reference');
    const type = searchParams.get('type');

    if (reference && type) {
      setCurrentReference(reference);
      setCurrentServiceCode(type);
      // Automatically fetch credit report
      
      fetchCreditReport(reference, type);
    } else {
      console.error('Missing params - Reference:', reference, 'Type:', type);
      showErrorToast('Missing reference or type parameter in URL');
    }
  }, [searchParams]); // Use searchParams as dependency

  const fetchCreditReport = async (reference, type) => {
  //console.log('Fetching credit report for:', { reference, type });
  setShowLoader(true);
  

try {
  setShowLoader(true);
  setModalOpen(false);
  setReportData(null);
  setReportError(null);
  setReportMessage(null);

  const result = await downloadCreditReport(reference, type);

  // Check if it's an error response (404, expired, etc.)
  const isError = 
    result?.status?.type === "error" ||
    result?.status?.code === 404 ||
    result?.message === "Report expired";

  // Check for successful response with actual data
  const isRealSuccess =
    result?.success === true &&
    result?.data?.http_response_code === 200 &&
    result?.data?.message === "success";

  // Check if data object exists and has content
  const hasReportData = result?.data && 
    typeof result.data === 'object' && 
    Object.keys(result.data).length > 0 &&
    !result.data.message?.toLowerCase().includes('expired');

 // console.log("isError:", isError);
 // console.log("isRealSuccess:", isRealSuccess);
//console.log("hasReportData:", hasReportData);

  if (isError) {
    // Expired or error response - show error message
    const errorMessage = 
      result?.status?.message ||
      result?.message ||
      "Report expired or not available";
    
    setReportError(errorMessage);
    setReportData(null);
    setModalOpen(false);
    
  } else if (isRealSuccess || hasReportData) {
    // Has valid data - show modal
    setReportData(result.data);
    setReportError(null);
    setModalOpen(true);
    
  } else {
    // Unknown state - show generic error
    setReportError("Report not available or Expired");
    setReportData(null);
    setModalOpen(false);
  }

} catch (error) {
  console.error("Error downloading credit report:", error);

  // Handle axios error response
  const errorData = error?.response?.data;
  const errorMessage = 
    errorData?.status?.message ||
    errorData?.message ||
    error?.message ||
    "Something went wrong while fetching the report.";

  setReportError(errorMessage);
  setReportData(null);
  setModalOpen(false);

} finally {
  setShowLoader(false);
}


};


  const handleCloseModal = () => {
    setModalOpen(false);
    setReportData(null);
    setReportError(null);
    setCurrentServiceCode('');
    setReportMessage('');
    setCurrentReference('');
  };


  // Render the appropriate modal based on service code
const renderModal = () => {
  // Don't render if modal is closed OR if there's an error with no data
  if (!modalOpen || (reportError && !reportData)) return null;

  const commonProps = {
    isOpen: modalOpen,
    onClose: handleCloseModal,
    Equifaxv2Error: reportError || reportData,
    displayMessageBlock: Boolean(reportMessage || reportError),
    reportMessage: reportMessage,
    reportCode: currentServiceCode,
  };

  switch (currentServiceCode) {
    // Experian V1
    case 'SVC0028':
      return (
        <ExperianScoreReportModals
          {...commonProps}
          ExperianReport={reportData?.data || reportData || {}}
          Equifaxv2Error={reportData || {}}
        />
      );

    // Experian V2
    case 'SVC0039':
      return (
        <ExperianScoreReportModal
          {...commonProps}
          ExperianReport={reportData?.result?.result_json?.INProfileResponse || reportData?.data || reportData || {}}
          Equifaxv2Error={reportData || {}}
        />
      );

    // Experian V3
    case 'SVC0141':
      return (
        <ExperianScoreReportModal3
          {...commonProps}
          ExperianReport={reportData?.result?.result_json?.INProfileResponse || reportData?.data || reportData || {}}
          Equifaxv2Error={reportData || {}}
        />
      );

    // TransUnion V1
    case 'SVC0027':
      return (
        <TransUnionReportModal
          {...commonProps}
          TransUnionReport={reportData?.data?.credit_report || reportData?.data || reportData || {}}
          Equifaxv2Error={reportData || {}}
        />
      );

    // TransUnion V2
    case 'SVC0143':
      return (
        <TransUnionReportModal2
          {...commonProps}
          TransUnionReport={reportData?.data?.credit_report || reportData?.data || reportData || {}}
          Equifaxv2Error={reportData || {}}
        />
      );

    // Equifax V2
    case 'SVC0029':
      return (
        <EquifaxScoreReportModal
          {...commonProps}
          Equifaxv2Report={reportData?.data?.credit_report || reportData?.credit_report || reportData?.data || reportData || {}}
          Equifaxv2Error={reportData || {}}
          submittedName={reportData?.name || reportData?.data?.name}
          submittedMobile={reportData?.mobile || reportData?.data?.mobile}
        />
      );

    // CRIF V1
    case 'SVC0075':
      return (
        <CrifScoreReportModal
        isPdf={true}
          {...commonProps}
          Equifaxv2Report={reportData?.data || reportData || {}}
          Equifaxv2Error={reportData || {}}
          submittedName={reportData?.name || reportData?.data?.name}
          submittedMobile={reportData?.mobile || reportData?.data?.mobile}
        />
      );

    // CRIF V2
    case 'SVC0128': // Fixed: was 'SVC00128' (extra 0)
      return (
        <CrifScoreReportModal2
          {...commonProps}
          Equifaxv2Report={reportData?.data || reportData || {}}
          Equifaxv2Error={reportData || {}}
          submittedName={reportData?.name || reportData?.data?.name}
          submittedMobile={reportData?.mobile || reportData?.data?.mobile}
        />
      );

    // Mobile Credit Score
    case 'SVC0065':
      return (
        <MobileDataModal
          {...commonProps}
          mobileResponseData={reportData?.data || reportData || {}}
        />
      );

    default:
      console.error(`Unsupported service code: ${currentServiceCode}`);
      showErrorToast(`No modal available for service code: ${currentServiceCode}`);
      setTimeout(() => {
        setModalOpen(false);
        setReportError(`Unsupported service: ${currentServiceCode}`);
      }, 2000);
      return null;
  }
};



return (
  <>
    <Seo title="Credit Report Viewer" description="View your credit report" />
    {showLoader && <Loader />}
    
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="w-full max-w-2xl px-4">
        
       
{!modalOpen && reportError && (
  <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded shadow">
    <h3 className="text-xl font-semibold mb-2 text-center text-red-600">
      {reportError}
    </h3>
    <div className="text-center mt-2 text-gray-600">
      {reportError.toLowerCase().includes('expired') 
        ? 'This report link has expired. Please generate a new report.' 
        : 'Report not available or expired at this moment.'}
    </div>
  </div>
)}



      </div>
    </div>

    {/* Only render modal when explicitly opened */}
    {modalOpen && reportData && !reportError && (
  renderModal()
)}
  </>
)
}

export default CreditScorePDF
